class Color {
  // constructor() { }

  static formatColor(color: string): string {
    if (color.startsWith('#') && color.length === 4) {
      let newColor = '';
      color.split('').forEach((value, index) => {
        newColor += !index ? value : value + value;
      });

      return newColor;
    }

    return color;
  }
}

export default Color;
